import React from 'react';
import { Button } from 'antd-v5';
import NewPopConfirm from '../../../../Layout/NewPopConfirm';
import './styles.css';

const DeleteBankAccountModal = ({ onCancel, onConfirm }) => {
  return (
    <NewPopConfirm className="cb-delete-bank-account-modal">
      <h3 className="cb-delete-bank-account-modal__title">Delete Account</h3>

      <p className="cb-delete-bank-account-modal__subtitle">Are you sure you want to delete this account?</p>

      <p className="cb-delete-bank-account-modal__description">
        All stores connected to this account will be assigned to your Default Bank Account. All historical data will be
        saved.
      </p>
      <div className="flex-row-center" style={{ gap: '12px' }}>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" size="large" onClick={onConfirm}>
          Continue
        </Button>
      </div>
    </NewPopConfirm>
  );
};

export default DeleteBankAccountModal;
